import {
  convertValue,
  getDecimalPoint,
  MEASUREMENT_KEYS,
  reportColumnEnums,
  GlobalUnitEnum,
} from "../unit-conversion";

// let tlogInput = {
//   sl_no: 13,
//   status: "-",
//   event: "777777777777777777777777_259221",
//   time: "19:37:10",
//   tilt: "27",
//   pass: "-",
//   zone: "CS",
//   distance: "9.828",
//   travelSpeed: "23.0",
//   volts: "25.02",
//   current: "337.4",
//   wireSpeed: "330.1",
//   oscillationWidth: "0.13",
//   target: "25",
//   horizontalBias: "0",
//   frequency: "200",
//   totalWireConsumed: "0.000",
//   trueEnergy: "22.0",
//   heat: "22.02",
// };

const mapTlogWithUnitConversion = (
  tlogInput,
  reportColumns,
  globalUnit = GlobalUnitEnum.IMPERIAL
) => {
  //   let reportColumns = {
  //     switch: "All",
  //     params: ["Arc Current", "Arc Volts", "Travel Speed", "Wire Speed", "Heat"],
  //     units: {
  //       ArcCurrent: "A",
  //       ArcVolts: "V",
  //       "Travel Speed": "in/min",
  //       "True Energy": "kJ/in",
  //       Heat: "kJ/in",
  //       "Wire Speed": "in/min",
  //       "Oscillation Width": "in",
  //       Frequency: "cyc/min",
  //       Target: "A",
  //       "Horizontal Bias": "A",
  //       "Total Wire Consumed": "in",
  //       "Band Diameter": "in",
  //       "Wire Diameter": "in",
  //       "Logging Distance": "in",
  //       Distance: "in",
  //     },
  //   };

  tlogInput.distance = convertValue(
    tlogInput.distance,
    reportColumns?.units?.["Logging Distance"],
    false,
    getDecimalPoint(MEASUREMENT_KEYS.DISTANCE, globalUnit)
  );
  tlogInput.travelSpeed = convertValue(
    tlogInput.travelSpeed,
    reportColumns?.units?.["Travel Speed"],
    false,
    getDecimalPoint(MEASUREMENT_KEYS.TRAVEL_SPEED, globalUnit)
  );
  tlogInput.volts = convertValue(
    tlogInput.volts,
    reportColumns?.units?.ArcVolts,
    false,
    getDecimalPoint(MEASUREMENT_KEYS.VOLTS, globalUnit)
  );
  tlogInput.current = convertValue(
    tlogInput.current,
    reportColumns?.units?.ArcCurrent,
    false,
    getDecimalPoint(MEASUREMENT_KEYS.AMPS, globalUnit)
  );
  tlogInput.wireSpeed = convertValue(
    tlogInput.wireSpeed,
    reportColumns?.units?.["Wire Speed"],
    false,
    getDecimalPoint(MEASUREMENT_KEYS.WIRE_SPEED, globalUnit)
  );
  tlogInput.oscillationWidth = convertValue(
    tlogInput.oscillationWidth,
    reportColumns?.units?.["Oscillation Width"],
    false,
    getDecimalPoint(MEASUREMENT_KEYS.OSCILLATE_WIDTH, globalUnit)
  );

  tlogInput.target = convertValue(
    tlogInput.target,
    reportColumns?.units?.Target,
    false,
    getDecimalPoint(MEASUREMENT_KEYS.TARGET, globalUnit)
  );

  tlogInput.horizontalBias = convertValue(
    tlogInput.horizontalBias,
    reportColumns?.units?.["Horizontal Bias"],
    false,
    getDecimalPoint(MEASUREMENT_KEYS.HORIZONTAL_BIAS, globalUnit)
  );

  tlogInput.frequency = convertValue(
    tlogInput.frequency,
    reportColumns?.units?.Frequency,
    false,
    getDecimalPoint(MEASUREMENT_KEYS.FREQUENCY, globalUnit)
  );

  tlogInput.totalWireConsumed = convertValue(
    tlogInput.totalWireConsumed,
    reportColumns?.units?.["Total Wire Consumed"],
    false,
    getDecimalPoint(MEASUREMENT_KEYS.TOTAL_WIRE_CONSUMED, globalUnit)
  );

  tlogInput.trueEnergy = convertValue(
    tlogInput.trueEnergy,
    reportColumns?.units?.["True Energy"],
    false,
    getDecimalPoint(MEASUREMENT_KEYS.TRUE_ENERGY, globalUnit)
  );

  tlogInput.heat = convertValue(
    tlogInput.heat,
    reportColumns?.units?.Heat,
    false,
    getDecimalPoint(MEASUREMENT_KEYS.HEAT, globalUnit)
  );

  return tlogInput;
};

const mappingColumnTableLimit = {
  volts: "volts",
  current: "current",
  wireSpeed: "wire_speed",
  oscillationWidth: "oscillation_width",
  trueEnergy: "heat",
  heat: "calculated_heat",
  travelSpeed: "travel_speed",
};

const rangeCalculation = (
  value,
  column,
  reportColumns,
  isFromPQRTab,
  globalUnit = GlobalUnitEnum.IMPERIAL
) => {
  let reverseMappingToReportColumns = {
    volts: "ArcVolts",
    current: "ArcCurrent",
    wire_speed: "Wire Speed",
    oscillation_width: "Oscillation Width",
    heat: "True Energy",
    calculated_heat: "Heat",
    travel_speed: "Travel Speed",
  };

  const getDecimalPointsValue = (columnValue) => {
    switch (columnValue) {
      case reverseMappingToReportColumns.volts:
        return getDecimalPoint(MEASUREMENT_KEYS.VOLTS, globalUnit);
      case reverseMappingToReportColumns.current:
        return getDecimalPoint(MEASUREMENT_KEYS.CURRENT_A, globalUnit);
      case reverseMappingToReportColumns.wire_speed:
        return getDecimalPoint(MEASUREMENT_KEYS.WIRE_SPEED, globalUnit);
      case reverseMappingToReportColumns.oscillation_width:
        return getDecimalPoint(MEASUREMENT_KEYS.OSCILLATE_WIDTH, globalUnit);
      case reverseMappingToReportColumns.heat:
        return getDecimalPoint(MEASUREMENT_KEYS.TRUE_ENERGY, globalUnit);
      case reverseMappingToReportColumns.calculated_heat:
        return getDecimalPoint(MEASUREMENT_KEYS.HEAT, globalUnit);
      case reverseMappingToReportColumns.travel_speed:
        return getDecimalPoint(MEASUREMENT_KEYS.TRAVEL_SPEED, globalUnit);
    }
  };

  return convertValue(
    value,
    isFromPQRTab
      ? ""
      : reportColumns?.units?.[reverseMappingToReportColumns?.[column]] || "",
    false,
    getDecimalPointsValue(reverseMappingToReportColumns?.[column])
  );
};

const returnUnitBasedOnColumns = (column, reportColumns) => {
  switch (column) {
    case reportColumnEnums.LoggingDistance:
    case reportColumnEnums.WireDiameter:
    case reportColumnEnums.Distance:
    case reportColumnEnums.BandDiameter: {
      return reportColumns?.units?.[column] || "in";
    }
  }
};

const mapTlogColumns = (
  inputColumns,
  reportColumns,
  isFromPQRReport,
  isM500 = false
) => {
  const columnsMapping = {
    CURRENT_A: "current",
    VOLT_V: "volt",
    TRAVEL_SPEED: "travelSpeed",
    TRUE_ENERGY: "trueEnergy",
    DISTANCE: "distance",
    HEAT: "heat",
    WIRE_SPEED: "wireSpeed",
    OSCILLATION_WIDTH: "oscillationWidth",
    FREQUENCY: "frequency",
    TARGET: "target",
    HORIZONTAL_BIAS: "horizontalBias",
    TOTAL_WIRE_CONSUMED: "totalWireConsumed",
    HEAD_ANGLE: "headAngle",
    ARC_IMPEDANCE: "arcImpedance",
    PIPE: "pipe",
  };

  return inputColumns
    ?.map((ite) => {
      let changeKeys = [
        columnsMapping.CURRENT_A,
        columnsMapping.VOLT_V,
        columnsMapping.TRAVEL_SPEED,
        columnsMapping.DISTANCE,
        columnsMapping.TRUE_ENERGY,
        columnsMapping.HEAT,
        columnsMapping.WIRE_SPEED,
        columnsMapping.OSCILLATION_WIDTH,
        columnsMapping.FREQUENCY,
        columnsMapping.TARGET,
        columnsMapping.HORIZONTAL_BIAS,
        columnsMapping.TOTAL_WIRE_CONSUMED,
        columnsMapping.HEAD_ANGLE,
        columnsMapping.ARC_IMPEDANCE,
      ];

      const m500Columns = [
        columnsMapping.HEAD_ANGLE,
        columnsMapping.ARC_IMPEDANCE,
        columnsMapping.PIPE,
      ];

      if (changeKeys.includes(ite.key)) {
        if (!isM500 && m500Columns.includes(ite.key)) {
          return null;
        }
        switch (ite.key) {
          case columnsMapping.CURRENT_A: {
            return {
              ...ite,
              title: `Current (${
                isFromPQRReport ? "A" : reportColumns?.units?.ArcCurrent || "A"
              })`,
              headerName: `Current (${
                isFromPQRReport ? "A" : reportColumns?.units?.ArcCurrent || "A"
              })`,
            };
          }
          case columnsMapping.VOLT_V: {
            return {
              ...ite,
              title: `Volt (${
                isFromPQRReport ? "V" : reportColumns?.units?.ArcVolts || "V"
              })`,
              headerName: `Volt (${
                isFromPQRReport ? "V" : reportColumns?.units?.ArcVolts || "V"
              })`,
            };
          }

          case columnsMapping.TRAVEL_SPEED: {
            return {
              ...ite,
              title: `Travel Speed (${
                isFromPQRReport
                  ? "in/min"
                  : reportColumns?.units?.["Travel Speed"] || "in/min"
              })`,
              headerName: `Travel Speed (${
                isFromPQRReport
                  ? "in/min"
                  : reportColumns?.units?.["Travel Speed"] || "in/min"
              })`,
            };
          }

          case columnsMapping.TRUE_ENERGY: {
            return {
              ...ite,
              title: `True Energy (${
                isFromPQRReport
                  ? "KJ/in"
                  : reportColumns?.units?.["True Energy"] || "KJ/in"
              })`,
              headerName: `True Energy (${
                isFromPQRReport
                  ? "KJ/in"
                  : reportColumns?.units?.["True Energy"] || "KJ/in"
              })`,
            };
          }

          case columnsMapping.HEAT: {
            return {
              ...ite,
              title: `Heat (${
                isFromPQRReport
                  ? "KJ/in"
                  : reportColumns?.units?.Heat || "KJ/in"
              })`,
              headerName: `Heat (${
                isFromPQRReport
                  ? "KJ/in"
                  : reportColumns?.units?.Heat || "KJ/in"
              })`,
            };
          }

          case columnsMapping.WIRE_SPEED: {
            return {
              ...ite,
              title: `Wire Speed (${
                isFromPQRReport
                  ? "in/min"
                  : reportColumns?.units?.["Wire Speed"] || "in/min"
              })`,
              headerName: `Wire Speed (${
                isFromPQRReport
                  ? "in/min"
                  : reportColumns?.units?.["Wire Speed"] || "in/min"
              })`,
            };
          }

          case columnsMapping.OSCILLATION_WIDTH: {
            return {
              ...ite,
              title: `Oscillation Width (${
                isFromPQRReport
                  ? "in"
                  : reportColumns?.units?.["Oscillation Width"] || "in"
              })`,
              headerName: `Oscillation Width (${
                isFromPQRReport
                  ? "in"
                  : reportColumns?.units?.["Oscillation Width"] || "in"
              })`,
            };
          }

          case columnsMapping.FREQUENCY: {
            return {
              ...ite,
              title: `Frequency (${
                isFromPQRReport
                  ? "cyc/min"
                  : reportColumns?.units?.Frequency || "cyc/min"
              })`,
              headerName: `Frequency (${
                isFromPQRReport
                  ? "cyc/min"
                  : reportColumns?.units?.Frequency || "cyc/min"
              })`,
            };
          }

          case columnsMapping.TARGET: {
            return {
              ...ite,
              title: `Target (${
                isFromPQRReport ? "A" : reportColumns?.units?.Target || "A"
              })`,
              headerName: `Target (${
                isFromPQRReport ? "A" : reportColumns?.units?.Target || "A"
              })`,
            };
          }

          case columnsMapping.HORIZONTAL_BIAS: {
            return {
              ...ite,
              title: `Horizontal Bias (${
                isFromPQRReport
                  ? "A"
                  : reportColumns?.units?.["Horizontal Bias"] || "A"
              })`,
              headerName: `Horizontal Bias (${
                isFromPQRReport
                  ? "A"
                  : reportColumns?.units?.["Horizontal Bias"] || "A"
              })`,
            };
          }

          case columnsMapping.TOTAL_WIRE_CONSUMED: {
            return {
              ...ite,
              title: `Total Wire Consumed (${
                isFromPQRReport
                  ? "in"
                  : reportColumns?.units?.["Total Wire Consumed"] || "in"
              })`,
              headerName: `Total Wire Consumed (${
                isFromPQRReport
                  ? "in"
                  : reportColumns?.units?.["Total Wire Consumed"] || "in"
              })`,
            };
          }

          case columnsMapping.DISTANCE: {
            return {
              ...ite,
              title: `Distance (${
                isFromPQRReport
                  ? "in"
                  : reportColumns?.units?.["Logging Distance"] || "in"
              })`,
              headerName: `Distance (${
                isFromPQRReport
                  ? "in"
                  : reportColumns?.units?.["Logging Distance"] || "in"
              })`,
            };
          }
          case columnsMapping.HEAD_ANGLE: {
            return {
              ...ite,
              title: `Head Angle (${
                isFromPQRReport
                  ? "deg"
                  : reportColumns?.units?.["Head Angle"] || "deg"
              })`,
              headerName: `Head Angle (${
                isFromPQRReport
                  ? "deg"
                  : reportColumns?.units?.["Head Angle"] || "deg"
              })`,
            };
          }
          case columnsMapping.ARC_IMPEDANCE: {
            // Arc Impedance has only one unit (ohms), no variations.
            return {
              ...ite,
              title: `Arc Impedance (${
                isFromPQRReport
                  ? "ohms"
                  : reportColumns?.units?.["Arc Impedance"] || "ohms"
              })`,
              headerName: `Arc Impedance (${
                isFromPQRReport
                  ? "ohms"
                  : reportColumns?.units?.["Arc Impedance"] || "ohms"
              })`,
            };
          }
        }
      } else {
        if (!isM500 && m500Columns.includes(ite.key)) {
          return null;
        }
        return ite;
      }
    })
    .filter((ite) => ite);
};

export const applyConversionFactor = (value, factor) => {
  if (!value || value === "") return "";
  const numValue = parseFloat(value);
  return isNaN(numValue) ? value : (numValue * (factor || 1)).toFixed(2);
};

/**
 * Get range display for table limits
 * @param {Object} params - Parameters object
 * @param {Object} params.tlogItem - Tlog item data
 * @param {Array} params.limitData - Table limit data
 * @param {Object} params.reportColumns - Report columns configuration
 * @param {string} params.column - Column name to get range for
 * @returns {Object} - Object with doesExist and showColor properties
 */
const getRangeDisplay = ({
  tlogItem,
  limitData,
  reportColumns,
  column,
  globalUnit = GlobalUnitEnum.IMPERIAL,
}) => {
  if (!tlogItem?.pass_name) {
    return { doesExist: false, showColor: "" };
  }

  const passName = tlogItem?.pass_name;
  const job_number = tlogItem?.job_number;
  const zone_name = tlogItem?.zone_name;

  let tableLimitFiltered = job_number
    ? limitData?.filter((tbLimit) => tbLimit.job_number === job_number)
    : [];

  // Try to match by zone_name first, then by pass_name
  tableLimitFiltered = tableLimitFiltered?.filter((tbLimit) => {
    // Check if zone_name matches (handle JSON string)
    if (zone_name && tbLimit.zone_name) {
      try {
        const parsedZoneName =
          typeof tbLimit.zone_name === "string" &&
          tbLimit.zone_name.startsWith("{")
            ? JSON.parse(tbLimit.zone_name)
            : tbLimit.zone_name;

        if (
          parsedZoneName === zone_name ||
          (typeof parsedZoneName === "object" &&
            parsedZoneName.ZoneNum !== undefined)
        ) {
          return true;
        }
      } catch (e) {
        // If parsing fails, try direct comparison
        if (tbLimit.zone_name === zone_name) {
          return true;
        }
      }
    }

    // Check if pass_name matches
    if (passName && tbLimit.pass_name === passName) {
      return true;
    }

    return false;
  });

  // If no exact match found, try to use the first available limit record for this job
  if (tableLimitFiltered?.length === 0 && job_number) {
    tableLimitFiltered = limitData?.filter(
      (tbLimit) => tbLimit.job_number === job_number
    );
  }

  const uniquePassNames = [
    ...new Set(tableLimitFiltered?.map((ite) => ite.pass_name)),
  ];

  if (uniquePassNames?.length === 0) {
    return { doesExist: false, showColor: "" };
  }

  // Get the first matching limit record
  const limitRecord = tableLimitFiltered?.[0];
  if (!limitRecord) {
    return { doesExist: false, showColor: "" };
  }

  // Map column to the correct limit field names
  const columnMapping = {
    volts: "volts",
    current: "current",
    wire_speed: "wire_speed",
    oscillation_width: "oscillation_width",
    true_energy: "true_energy",
    heat: "heat",
    travel_speed: "travel_speed",
  };

  const mappedColumn = columnMapping[column] || column;
  const minKey = `${mappedColumn}_min`;
  const maxKey = `${mappedColumn}_max`;

  const minValue = limitRecord[minKey];
  const maxValue = limitRecord[maxKey];

  if (
    minValue === undefined ||
    maxValue === undefined ||
    minValue === null ||
    maxValue === null ||
    minValue === "" ||
    maxValue === ""
  ) {
    return { doesExist: false, showColor: "" };
  }

  // Format the range display
  const minFormatted = rangeCalculation(
    minValue,
    mappedColumn,
    reportColumns,
    false,
    globalUnit
  );
  const maxFormatted = rangeCalculation(
    maxValue,
    mappedColumn,
    reportColumns,
    false,
    globalUnit
  );

  return {
    doesExist: true,
    showColor: `[${minFormatted} - ${maxFormatted}]`,
  };
};

export const tlogHelper = {
  mapTlogWithUnitConversion,
  mapTlogColumns,
  mappingColumnTableLimit,
  rangeCalculation,
  returnUnitBasedOnColumns,
  getRangeDisplay,
};
